function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".d{stroke:#d3d3d3}.b,.c,.d{fill:none}.b,.c{stroke:#00857c}.c,.d{stroke-linecap:round}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#d3d3d3",
  fill: "#fff",
  strokeMiterlimit: 10
},
/*#__PURE__*/
React.createElement("rect", {
  width: 30,
  height: 20,
  rx: 2,
  stroke: "none"
}),
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5,
  fill: "none"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M18.5 1v18M29 9H1M18.331 8.536c-.738.534-6.931-2.062-4.939-4.709 2.921-2.178 5.259 4.481 4.939 4.709z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "c",
  d: "M22.156 12.414s-.766-.889-1.76-1.92-2.206-2.206-2.206-2.206"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M18.875 8.521c-.534-.738 1.99-6.651 4.709-4.939 2.219 2.841-4.481 5.259-4.709 4.939z"
}),
/*#__PURE__*/
React.createElement("path", {
  className: "c",
  d: "M15.14 12.612a22.25 22.25 0 011.532-1.781c.996-1.058 2.451-2.451 2.451-2.451"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "d",
  d: "M3.5 13.5h5M3.5 16.5h10"
});

var SvgGiftPayment = function SvgGiftPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 30,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgGiftPayment, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/GiftPayment.61ff30bf.svg";
export { ForwardRef as ReactComponent };